import AxiosInstance from '../config/AxiosInstance';

export interface Product {
    id: string;
    sku: string;
    type: number;
    productName: string;
    productGroup: { groupName: string };
    updatedAt: Date;
    isActive: boolean;
}


interface ProductAttributesPayload {
    productId: string;
    position: number;
}

interface AttributesSelectPayload {
    attributeId: string;
    position: number;
}

export interface SalePointPayload {
    companyId: string,
    position: number,
    salePointName: string,
    description: string,
    pricePointId?: string,
    attributes: AttributesSelectPayload[],
    products: ProductAttributesPayload[],
}

const createSalePoint = async (payload: SalePointPayload) => {
    try {
        const { data } = await AxiosInstance.post(`/api/inventory/sale-points/create`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailSalePoint = async (id: string, companyId: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/sale-points/find-one/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateSalePoint = async (id: string, companyId: string, payload: SalePointPayload) => {
    try {
        const { data } = await AxiosInstance.put(`/api/inventory/sale-points/update-one/${id}`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListSalePoint = async (companyId: string, page: string, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/sale-points/list`, {
            params: {
                page: page,
                limit: limit,
                companyId: companyId,
                searchValue: searchValue,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListSalePointForDashBoard = async (page: string, limit: number, searchName: string, searchDescription: string, searchPricePoint: string, searchPosition: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/sale-points/list-for-dashboard`, {
            params: {
                page: page,
                limit: limit,
                searchName: searchName,
                searchDescription: searchDescription,
                searchPricePoint: searchPricePoint,
                searchPosition: searchPosition,

            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteSalePoint = async (id: string, companyId: string) => {
    try {
        const { data } = await AxiosInstance.delete(`/api/inventory/sale-points/delete-one/${id}`);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createSalePoint,
    getListSalePoint,
    getDetailSalePoint,
    deleteSalePoint,
    updateSalePoint,
    getListSalePointForDashBoard
}